import clsx from 'clsx';
import React from 'react';

import BylineWithHeadshot from '@components/BylineWithHeadshot';
import ProExclusiveLogo from '@components/ProExclusiveLogo';
import { Project, TalentTrackerSidebarItem } from '@interfaces/projects';
import { ACCESS_PRO } from '@src/constants';
import { dateInLocalTimezone } from '@utils/dates';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import Sidebar from './Sidebar';

interface TopSectionProps
  extends Pick<
    Project,
    'accessLevel' | 'authors' | 'description' | 'title' | 'titleCallout' | 'updatedAt'
  > {
  className?: string;
  takeaways: TalentTrackerSidebarItem[];
  readMoreItems: TalentTrackerSidebarItem[];
}

const TopSection = ({
  accessLevel,
  authors,
  className,
  description,
  takeaways,
  readMoreItems,
  title,
  updatedAt,
}: TopSectionProps) => {
  return (
    <div className={clsx('mx-auto grid max-w-7xl grid-cols-1 md:grid-cols-4 md:gap-16', className)}>
      <div className="md:col-span-3">
        {accessLevel >= ACCESS_PRO && <ProExclusiveLogo align="left" />}
        <h1 className="mb-0 mt-24 font-suisse-screen text-headline-lg text-grayscale-charcoal sm:text-headline-alt-lg">
          <span className="block">Talent Tracker: </span>
          {title}
        </h1>
        <p className="mb-0 mt-24 w-full font-noto-serif text-body-articles">
          {AuthoredContentReactToHtmlParser(description)}
        </p>
        {authors?.length > 0 && (
          <p className="mb-0 mt-24 w-full">
            <BylineWithHeadshot
              authors={authors}
              className="font-suisse-screen text-byline-sm text-primary-black sm:text-byline-lg"
            />
          </p>
        )}
        <p className="mb-0 mt-8 font-suisse-screen text-[14px]/[100%] font-[375] italic">
          Last updated {dateInLocalTimezone(updatedAt)}
        </p>
      </div>
      <Sidebar takeaways={takeaways} readMoreItems={readMoreItems} />
    </div>
  );
};

export default TopSection;
